import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312 } from "@faire/web-api--source/indigofair/settings/OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312";

export const useSettingOwfApplicationFunnelOptimizations = (): boolean =>
  useSetting(OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312, false);

export const useAssignOwfApplicationFunnelOptimizations = () => {
  return useAssignSetting(OWF_APPLICATION_FUNNEL_OPTIMIZATIONS_XP_V2_250312);
};
        